import React from 'react';
import PT from 'prop-types';
import cn from 'classnames';

const ItemWrapper = ({ label, subLabel, children, className, error }) => {
  return (
    <div className={cn('input-block', className)}>
      {label && <p className="input-block__title">{label}</p>}
      {subLabel && <p className="input-block__description">{subLabel}</p>}
      <div className="input-block__input-wrapper">{children}</div>
      {error && typeof error !== 'object' && (
        <div className="input-block__error" data-testid="error-message">{error}</div>
      )}
    </div>
  );
};

ItemWrapper.propTypes = {
  label: PT.string,
  subLabel: PT.string,
  className: PT.string,
};

export default ItemWrapper;
